module.exports = __webpack_public_path__ + "dc44d60401258522b7dfce1d33ee31ef.jpg";